export type SupplierTier = 'FREE' | 'BASIC' | 'ENTERPRISE';

export type NavItem = {
    label: string;
    to: string;
    icon?: string;
    section?: string;
    comingSoon?: boolean;
    requiredTier?: SupplierTier;
};

export const supplierNavItems: NavItem[] = [
    { label: 'Dashboard', to: '/supplier', icon: 'LayoutDashboard', section: 'Main', requiredTier: 'BASIC' },
    { label: 'Company Profile', to: '/supplier/profile', icon: 'Building2', section: 'Main' },
    { label: 'Products', to: '/supplier/products', icon: 'Package', section: 'Main' },
    { label: 'Promotions', to: '/supplier/promotions', icon: 'Target', section: 'Main' },
    { label: 'Quotes', to: '/supplier/quotes', icon: 'MessageSquare', section: 'Main', requiredTier: 'ENTERPRISE' },
    { label: 'Channel Team', to: '/supplier/contacts', icon: 'Users' },
    { label: 'Content Library', to: '/supplier/training', icon: 'BookOpen', requiredTier: 'ENTERPRISE' },
    { label: 'Metrics Library', to: '/supplier/metrics', icon: 'TrendingUp', section: 'Main', requiredTier: 'ENTERPRISE' },
    { label: 'Solution Map', to: '/supplier/solution-map', icon: 'Map', section: 'Main', requiredTier: 'ENTERPRISE' },
    { label: 'Team Members', to: '/supplier/team', icon: 'UserCog', section: 'Settings', requiredTier: 'BASIC', comingSoon: true },
    { label: 'Settings', to: '/supplier/settings', icon: 'Settings', section: 'Settings', requiredTier: 'BASIC' },
    { label: 'Documentation', to: '/resources/docs', icon: 'FileText', section: 'Resources' },
    { label: 'Support', to: '/resources/support', icon: 'LifeBuoy', section: 'Resources' },
];

/**
 * FUTURE NAV ITEMS (not built yet):
 *
 * Deal Management:
 * - Forecasting: Pipeline forecast by close date, MRC projections
 * - Commission Tracker: Track expected vs received commissions across TSDs
 * - Deal Templates: Save common deal patterns for quick re-use
 *
 * Account Management:
 * - Account Health: At-a-glance health scores across all accounts
 * - Renewal Tracker: Contracts expiring soon across all accounts
 * - Account Activity Feed: Chronological feed of all activities across accounts
 *
 * Team (future multi-user):
 * - Team Pipeline: View across all team members' deals
 * - Team Leaderboard: Performance metrics
 * - Shared Deal Templates
 *
 * Integrations:
 * - CRM Sync: HubSpot/Zoho/Salesforce bi-directional sync
 * - Calendar: Meeting scheduling integration
 * - Email: Forward emails to auto-create activities
 */
export const advisorNavItems: NavItem[] = [
    { label: 'Today', to: '/advisor/today', icon: 'LayoutDashboard' },
    { label: 'Accounts', to: '/advisor/workspace/accounts', icon: 'Building' },
    { label: 'Supplier Directory', to: '/advisor/suppliers', icon: 'Building2' },
    { label: 'Community', to: '/advisor/community', icon: 'MessageCircle', comingSoon: true },
    { label: 'Contacts', to: '/advisor/contacts', icon: 'Users' },
    { label: 'Quotes', to: '/advisor/quotes', icon: 'FileText' },
    { label: 'Metrics', to: '/advisor/metrics', icon: 'TrendingUp', comingSoon: true },
    { label: 'Training Center', to: '/advisor/training', icon: 'GraduationCap' },
];

export const adminNavItems: NavItem[] = [
    { label: 'Dashboard', to: '/admin', icon: 'LayoutDashboard', section: 'Main' },
    { label: 'AI Models', to: '/admin/ai-models', icon: 'Brain', section: 'Main' },
    { label: 'AI Prompts', to: '/admin/ai-prompts', icon: 'Lightbulb', section: 'Main' },
    { label: 'AI Diagnostics', to: '/admin/ai-diagnostics', icon: 'Microscope', section: 'Main' },
    { label: 'Quote Queue', to: '/admin/quotes', icon: 'FileText', section: 'Main' },
    { label: 'Suppliers', to: '/admin/suppliers', icon: 'Building2', section: 'Management' },
    { label: 'Taxonomy', to: '/admin/taxonomy', icon: 'Tag', section: 'Main' },
    { label: 'TSDs', to: '/admin/tsds', icon: 'Handshake', section: 'Management' },
    { label: 'Users', to: '/admin/users', icon: 'Users', section: 'Management' },
    { label: 'Invite Codes', to: '/admin/invite-codes', icon: 'Ticket', section: 'Management' },
    { label: 'Create User', to: '/admin/create-user', icon: 'UserPlus', section: 'Management' },
];
